module.exports = __webpack_public_path__ + "static/img/wu.1daef53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wu.png
// module id = +E5Q
// module chunks = 1